import { render, staticRenderFns } from "./CInfoMixBackground.vue?vue&type=template&id=51863f32&scoped=true"
import script from "./CInfoMixBackground.vue?vue&type=script&lang=js"
export * from "./CInfoMixBackground.vue?vue&type=script&lang=js"
import style0 from "./CInfoMixBackground.vue?vue&type=style&index=0&id=51863f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51863f32",
  null
  
)

export default component.exports